











import Vue from "vue";

/**
 * rel="noopener"
 * https://stackoverflow.com/a/4964223/4906586
 */

export default Vue.extend<{}>({
  name: "BaseLink",
  functional: true
});
